import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { ActionButton, AltButton } from "../../../common/Buttons/Buttons.jsx";
import { Header } from "../../../common/Header/Header.jsx";
import {
  ParticularCounterTable,
  SupervisorParticularCounterTable,
} from "../../../common/Tables/Tables.jsx";
import {
  operatorParticularCounterHeader,
  ParticularCounterHeader,
  supervisorParticularCounterHeader,
} from "../../../../assets/helpers/tables.js";
import { notify } from "../../../../assets/helpers/toast.js";
import { servicesService } from "../../../../services/servicesService.js";
import { providersPaymentsTypes } from "../../../../assets/helpers/options.js";
import { SearchInput } from "../../../common/Forms/Input/Input.jsx";
import { filterParams } from "../../../../assets/helpers/funciones.js";
import moment from "moment";
import { LoadSpinner } from "../../../common/LoadSpinner/LoadSpinner.jsx";

import "./ParticularServicesCounter.scss";
import authService from "../../../../services/authService.js";
import { operationsRoles } from "../../../../assets/helpers/roles.js";

registerLocale("es", es);

const itemsPerpage = [10, 25, 50, 100, 500, 1000, 2500, 5000];

export const FilterButton = (props) => {
  const { label, type, action } = props;

  if (label === type) {
    return <ActionButton label={label} action={() => action(label)} />;
  } else {
    return <AltButton label={label} action={() => action(label)} />;
  }
};

export const ParticularServicesCounter = () => {
  const tableRef = useRef(null);
  const history = useHistory();

  const [sinceDate, setSinceDate] = useState(moment().startOf("month").toDate());
  const [untilDate, setUntilDate] = useState(moment().endOf("month").toDate());
  const user = authService.getUser();

  const [particularCountersDataTable, setParticularCountersDataTable] =
    useState({
      limit: itemsPerpage[2],
      offset: 0, //Elementos que ya pasaron la pagina
      data: [],
      count: 0, //Cantidad de elementos
      page: 1,
      sinceDate: "",
      untilDate: "",
      isInternal: true,
      isLoading: true,
      type: providersPaymentsTypes?.PAYMENT_AV,
      provider: "",
      paymentStatus: "",
    });

  const [
    supervisorParticularCountersDataTable,
    setSupervisorParticularCountersDataTable,
  ] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    sinceDate: "",
    untilDate: "",
    isInternal: true,
    isLoading: true,
    type: providersPaymentsTypes?.PAYMENT_AV,
    provider: "",
    paymentStatus: "",
  });

  const userRole = authService.getUserType();

  const handleMonthChange = (date) => {
    setSinceDate(moment(date).startOf("month").toDate());
    setUntilDate(moment(date).endOf("month").toDate());
  };

  const checkSupervisorsTable = (user) => {
    const rolesToCheck = [
      operationsRoles.operationsAdmin,
      operationsRoles.operationsSupervisor,
      operationsRoles.operationsDev,
    ];
    return user.roles.some((role) => rolesToCheck.includes(role.code));
  };

  const handlePageChange = (event, value) => {
    setParticularCountersDataTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * particularCountersDataTable?.limit,
      };
    });
  };

  function getExportables(type) {
    setParticularCountersDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    let params = {
      dateFrom: moment(sinceDate).format("YYYY-MM-DD"),
      dateTo: moment(untilDate).format("YYYY-MM-DD"),
      // limit: particularCountersDataTable?.limit,
      // offset: particularCountersDataTable?.offset,
      name: particularCountersDataTable?.name,
    };

    servicesService
      .getServicesByOperator(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setParticularCountersDataTable((prevState) => {
            return {
              ...prevState,
              data: response?.data,
              // count: response?.data?.count,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setParticularCountersDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => {
        setParticularCountersDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  }

  const getSupervisorServices = () => {
    setSupervisorParticularCountersDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    let params = {
      dateFrom: moment(sinceDate).format("YYYY-MM-DD"),
      dateTo: moment(untilDate).format("YYYY-MM-DD"),
    };

    servicesService
      .getSupervisorServices(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setSupervisorParticularCountersDataTable((prevState) => {
            if (
              userRole === operationsRoles.operationsSupervisor &&
              response?.data?.length > 0
            ) {
              response.data = response.data.filter(
                (item) => item._id !== "656e0fc12fd074bce973bf0d"
              );
            }
            return {
              ...prevState,
              data: response?.data,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setSupervisorParticularCountersDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => {
        setSupervisorParticularCountersDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const handleMultipleSelection = (value, name) => {
    let data = [...particularCountersDataTable?.data];

    for (let i = 0; i < data?.length; i++) {
      if (
        data[i]?.providerName === name &&
        data[i]?.providerPaymentStatus !== "Pagado"
      ) {
        data[i].selected = value;
      }
    }
    setParticularCountersDataTable((prevState) => {
      return {
        ...prevState,
        data: data,
      };
    });
  };

  const handleSearchChange = (e) => {
    const { value } = e?.target;
    setParticularCountersDataTable((prevState) => {
      return {
        ...prevState,
        name: value,
        page: 1,
        offset: 0,
      };
    });
    if (!value) {
      window.location.reload();
    }
  };

  const selectPayment = (payment, index) => {
    let datos = [...particularCountersDataTable?.data];
    datos[index].selected = !datos[index].selected;

    let none = "";

    for (let i = 0; i < datos.length; i++) {
      if (datos[i].selected) {
        none = payment?.status;
      }
    }

    setParticularCountersDataTable((prevState) => {
      return {
        ...prevState,
        data: datos,
        selectedType: none,
      };
    });
  };

  useEffect(() => {
    getExportables();
    getSupervisorServices();
  }, [
    particularCountersDataTable?.page,
    particularCountersDataTable?.offset,
    particularCountersDataTable?.limit,
    particularCountersDataTable?.type,
    particularCountersDataTable?.sinceDate,
    particularCountersDataTable?.untilDate,
    particularCountersDataTable?.provider,
    particularCountersDataTable?.paymentStatus,
    sinceDate,
    untilDate,
  ]);

  return (
    <>
      <LoadSpinner show={particularCountersDataTable.isLoading} />
      <Header />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">Comportamiento Operadores</h1>
          {checkSupervisorsTable(user) && (
            <ActionButton
              label="Comisiones"
              action={() => history.push("/stats/operators-counter/commissions")}
            />
          )}
        </div>
        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <div style={{ marginTop: "36px", marginRight: "12px" }}>
              <SearchInput
                placeholder={"Nombre"}
                width="260px"
                value={particularCountersDataTable?.description}
                onChange={handleSearchChange}
                searchAction={getExportables}
              />
            </div>
            <div className="input-component-container">
              <label htmlFor="selectedMonth">Fecha</label>
              <div>
                <DatePicker
                  id="selectedMonth"
                  selected={sinceDate}
                  onChange={handleMonthChange}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  locale="es"
                  maxDate={new Date()}
                  className="custom-datepicker"
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <span></span>
        </div>
        {checkSupervisorsTable(user) && (
          <SupervisorParticularCounterTable
            header={supervisorParticularCounterHeader}
            data={supervisorParticularCountersDataTable}
            tableRef={tableRef}
          />
        )}

        {!particularCountersDataTable.isLoading && (
          <ParticularCounterTable
            header={
              [operationsRoles.operationsOperator].includes(userRole)
                ? operatorParticularCounterHeader
                : ParticularCounterHeader
            }
            handlePageChange={handlePageChange}
            selectPayment={selectPayment}
            data={particularCountersDataTable}
            type={particularCountersDataTable?.type}
            tableRef={tableRef}
            handleMultipleSelection={handleMultipleSelection}
            userRole={userRole}
          />
        )}
      </div>
    </>
  );
};
